<template>
  <div class="document-container">
    <div class="document">
      <div class="header">
        <EsHeader>
          <template #header>
            <div class="header-title">
              Download Options
            </div>
          </template>
        </EsHeader>
      </div>
      <div class="content">
        <es-form>
          <template #es-form-header>
            <div class="header-container">
              <div class="header-elements">
                <font-awesome-icon :icon="['fas', 'file-edit']" size="lg"/>
              </div>
              <div class="header-elements">
                <h6 class="title">
                  Format
                </h6>
              </div>
            </div>
          </template>
          <template #es-form>
            <div class="fields-container">
              <div class="field is-horizontal ">
                <div class="field-label is-normal">
                  <label class="label">
                    File Format
                  </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="buttons has-addons">
                        <button
                          v-for="(option, index) in fileFormatOptions"
                          :key="index"
                          class="button no-radius"
                          :class="{'download-type': fileFormat === option}"
                          @click="selectType('fileFormat', option)"
                          style="width: 100px"
                        >
                          {{ option }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">
                    Delimiter
                  </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="buttons has-addons">
                        <button
                          v-for="(option, index) in delimiterOptions"
                          :key="index"
                          class="button no-radius"
                          :class="{'download-type': delimiter === option}"
                          @click="selectType('delimiter', option)"
                          style="width: 100px"
                        >
                          {{ option }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">
                    Qualifier
                  </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="buttons has-addons">
                        <button
                          v-for="(option, index) in qualifierOptions"
                          :key="index"
                          class="button no-radius"
                          :class="{'download-type': qualifier === option}"
                          @click="selectType('qualifier', option)"
                          style="width: 150px"
                        >
                          {{ option }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label" for="dateFormatLabel">
                    Date Format
                  </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="select is-half-width">
                        <select
                          class="input is-full-width"
                          v-model="dateFormat"
                          id="dateFormatLabel"
                        >
                          <option
                            v-for="(dateFormat, index) in dateFormatOptions"
                            :key="index"
                            :value="index"
                          >
                            {{ dateFormat }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">
                    Include Header/Footer
                  </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="buttons has-addons">
                        <button
                          v-for="(option, index) in includeHeaderFooterOptions"
                          :key="index"
                          class="button no-radius"
                          :class="{'download-type': includeHeaderFooter === option}"
                          @click="selectType('includeHeaderFooter', option)"
                          style="width: 100px"
                        >
                          {{ option }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </es-form>
      </div>
      <div class="es-actions">
        <es-form-actions>
          <template #form-actions>
            <div class="bottom-content">
              <ul>
                <li>
                  <div class="list-content">
                    <a class="no-wrap" @click="clearFields" @keypress="clearFields" role="button" tabindex="0">
                      Cancel
                    </a>
                  </div>
                </li>
                <li>
                  <div class="list-content">
                    <button
                      class="button is-primary"
                      @click="download"
                    >
                      Download
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </es-form-actions>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFileEdit,
} from '@fortawesome/pro-solid-svg-icons';
import EsForm from '@/components/EsForm.vue';
import EsFormActions from '@/components/EsFormActions.vue';
import EsHeader from '@/components/EsHeader.vue';
import NotificationManager from '@/mixins/NotificationManager';

library.add(
  faFileEdit,
);
export default {
  props: {
    school: {
      type: Object,
    },
  },
  mixins: [NotificationManager],
  components: {
    EsForm,
    EsFormActions,
    EsHeader,
  },
  data() {
    return {
      dateFormat: '0',
      dateFormatOptions: ['mm/dd/yyyy', 'ISO Format (YYYY-MM-DD)', 'm/d/yyyy', 'm/dd/yyyy'],
      delimiter: 'Tab',
      delimiterOptions: ['Tab', 'Comma'],
      fileFormat: 'Version 3.0',
      fileFormatOptions: ['Version 3.0', 'Version 2.1', 'Version 1.0'],
      formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
      includeHeaderFooter: 'Yes',
      includeHeaderFooterOptions: ['Yes', 'No'],
      qualifier: 'Double Quotes ( " )',
      qualifierOptions: ['Double Quotes ( " )', "Single Quote ( ' )"],
    };
  },
  methods: {
    clearFields() {
      this.resetForm();
    },
    download() {
      //download
    },
    resetForm() {
      //  Object.assign(this.$data, this.$options.data.call(this));
      this.fileFormat = 'Version 3.0';
      this.delimiter = 'Tab';
      this.qualifier = 'Double Quotes ( " )';
      this.dateFormat = '0';
      this.includeHeaderFooter = 'Yes';
    },
    selectType(field, option) {
      if (field === 'fileFormat') {
        this.fileFormat = option;
      }
      if (field === 'delimiter') {
        this.delimiter = option;
      }
      if (field === 'qualifier') {
        this.qualifier = option;
      }
      if (field === 'includeHeaderFooter') {
        this.ignoreFirstRow = option;
      }
    },
    showMessage() {
      const type = this.hasError ? 'danger' : 'success';
      this.showNotification(type, this.messages);
    },
  },
};
</script>

<style lang="sass" scoped>
  .tabs
    padding: 1rem 1rem 0 1rem
    a
      &:hover
        text-decoration: none
  .header-container
    margin-bottom: 1rem
  .no-radius
    border-radius: 0
    background-color: #F2F2F2
    font-weight: normal
  .download-type
    background-color: #ccc
    font-weight: bold
  .no-wrap
    white-space: nowrap
  .fields-container
      margin-left: 30px
</style>
